import { isRequired, isTimeValid, isEmail } from 'utils/validators';
import moment from 'moment';

const SINGLE_DATE = 'pricesHourlyForm';
const MULTI_DATES = ['pricesFixedForm', 'pricesDailyForm', 'pricesWeeklyForm'];

const validate = (values) => {  
  const errors = {};

  if (values.availableUnits && values.availableUnits.length) {
    let availableUnitsArrayErrors = [];
    let isValidAvailableUnits = false;

    values.availableUnits.forEach((item, index) => {
      if (item.availableUnits && parseInt(item.availableUnits) > 0) {
        isValidAvailableUnits = true;
      }
      availableUnitsArrayErrors[index] = { availableUnits: 'Error' };
    });

    if (!isValidAvailableUnits) {
      errors.availableUnits = {
        ...availableUnitsArrayErrors,
        _error: 'Value for at least one unit should be filled in'
      };
    }
  }

  if (
    !errors.availableUnits &&
    values.availableUnits &&
    values.availableUnits.length
  ) {
    const availableUnitsNumber = values.maxAvailableUnits;
    
    const availableUnitsArrayErrors = [];
    let totalAvailableUnits = 0;

    values.availableUnits.forEach((item, index) => {
      if (item.availableUnits && item.availableUnits.length) {
        totalAvailableUnits += parseInt(item.availableUnits);
      }
      availableUnitsArrayErrors[index] = { availableUnits: 'Error' };
    });

    if (totalAvailableUnits > availableUnitsNumber) {
      errors.availableUnits = {
        ...availableUnitsArrayErrors,
        _error: `The number of available units can’t exceed ${availableUnitsNumber}`
      };
      errors.isMaxUnitsErrors = true;
    }
  }

  const hasMultiDates = values.multiDates?.startDate && values.multiDates?.endDate;
  const hasStartingDate = values.startingDate;
  const minDays = values.minDays;
  const maxDays = values.maxDays;

  if (values.pricesType === SINGLE_DATE) {
    if (!hasStartingDate) {
      errors.startingDate = 'Starting date is required';
    }
  } else if (MULTI_DATES.includes(values.pricesType)) {
    if (!hasMultiDates) {
      errors.multiDates = 'Date range is required';
      return errors; 
    }

    const totalDays = moment(values.multiDates.endDate).diff(
      moment(values.multiDates.startDate),
      'days'
    ) + 1;

    if (minDays != null && totalDays < minDays) {
      errors.multiDates = `The number of days cannot be less than ${minDays} `;
    }

    if (maxDays != null && totalDays > maxDays) {
      errors.multiDates = `The number of days cannot be more than ${maxDays} `;
    }
  }

  if (values.pricesType === SINGLE_DATE) {
    if (!isTimeValid(values.startTime)) {
      errors.startTime = 'Start time is required';
    }

    if (!isTimeValid(values.endTime)) {
      errors.endTime = 'End time is required';
    }

    if (values.startTime && values.endTime && values.minMaxHours) {
      const startTime = moment.isMoment(values.startTime)
        ? values.startTime
        : moment(values.startTime);
      const endTime = moment.isMoment(values.endTime)
        ? values.endTime
        : moment(values.endTime);

      if (startTime.isValid() && endTime.isValid()) {
        const hoursDifference = endTime.diff(startTime, 'hours', true);
        const { minHours, maxHours } = values.minMaxHours;

      
        if (minHours && hoursDifference < minHours) {
          const errorMsg = `Minimum rental duration is ${minHours} hours`;
          errors.endTime = errorMsg;
          errors.isMinMaxHoursError = true;
        } else if (maxHours && hoursDifference > maxHours) {
          const errorMsg = `Maximum rental duration is ${maxHours} hours`;
          errors.endTime = errorMsg;
          errors.isMinMaxHoursError = true;
        }

      }
    }
  }


  if (isRequired(values.firstName || '', true)) {
    errors.firstName = 'First name is required';
  }

  if (isRequired(values.lastName || '', true)) {
    errors.lastName = 'Last name is required';
  }

  if (isRequired(values.phone || '', true)) {
    errors.phone = 'Phone is required';
  }

  if (isRequired(values.email || '', true)) {
    errors.email = 'Email is required';
  } else if (isEmail(values.email || '', true)) {
    errors.email = 'Invalid email';
  }

  return errors;
};

export default validate;